import React, { useEffect, useRef, useState } from "react";
import {
  CHEVRON_DOWN,
  CHEVRON_LEFT,
  CLOSE,
  EDIT_ICON,
  FILTER,
  PROFILE_ADD,
  SEARCH_INPUT_ICON,
} from "../../../assets";
import { motion } from "framer-motion";
import {
  JUDICIAL_COLUMN,
  LGA_COLUMN,
  PLATFORM_CHARGE,
  STATE_COLUMN,
} from "../../../shared/components/table/columns";
import { useQuery } from "react-query";
import {
  getJudicialDivisions,
  getLocalGovernment,
  getStates,
} from "../../../Services/services";
import RoundedTable from "../../../shared/components/table/roundedTable";
import ButtonV2 from "../../../shared/components/buttonV2";
import {
  createJudicialDivision,
  createLga,
  deleteJudicialDivision,
  deleteLga,
  getJudicialDivisionsAdmin,
  getPlatformCharge,
  updateJudicialDivision,
  updateLga,
  updatePlatformCharge,
} from "../../../Services/admin.service";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  selectEditMode,
  selectJudicialDivision,
  selectJudicialDivisonDeleteModal,
  selectJudicialModal,
  selectLocalGovernMent,
  selectLocalGovernMentDeleteModal,
  setEditMode,
  setJudicialDivisionDeleteModal,
  setJudicialDivisionModal,
  setLocalgovernment,
  setLocalgovernmentDeleteModal,
  setLocalgovernmentModal,
  setPlatformModal,
  showLocalGovernMentModal,
  showPlatformChargeModal,
} from "../../../states/slices/globalReducer";
import { toast } from "react-hot-toast";
import ModalV2 from "../../../shared/components/modalV2";
import { Loader2 } from "lucide-react";
import { SearchHistoryTypes } from "../../../types";

export function States() {
  const [searchQuery, setSearchQuery] = useState("");

  const { data: states, isLoading } = useQuery("states", getStates);
  return (
    <div className="flex flex-col gap-y-3 w-full">
      <span className="text-sm sm:text-[16px] text-[#2A2E34] font-semibold">
        States Management
      </span>
      <div className="w-full max-w-md items-center gap-x-2 flex px-3 py-2 rounded-xl border border-borderColor">
        <img
          src={SEARCH_INPUT_ICON}
          className="w-[20px] h-[20px] flex-shrink-0"
          alt=""
        />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full bg-transparent placeholder:text-sm outline-none"
          placeholder="Search users"
        />
      </div>

      <div className="w-full overflow-x-auto">
        {states?.length > 0 ? (
          <RoundedTable DATA={states} COLUMNS={STATE_COLUMN} />
        ) : isLoading ? (
          <div className="flex items-center justify-center">
            <Loader2 color="#d1d5db" className="animate-spin" />
          </div>
        ) : (
          <div>hello</div>
        )}
      </div>
    </div>
  );
}

export function LocalGovernment() {
  const [searchQuery, setSearchQuery] = useState("");
  const [lganame, setLganame] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const {
    data: lga,
    refetch,
    isLoading: loadingLga,
  } = useQuery(["lga", currentPage], () => getLocalGovernment(currentPage));
  const dispatch = useAppDispatch();
  const localGovernmentModal = useAppSelector(showLocalGovernMentModal);
  const [loading, setLoading] = useState(false);
  const localgovernment = useAppSelector(selectLocalGovernMent);
  const editmode = useAppSelector(selectEditMode);
  const localGovernmentDeleteModal = useAppSelector(
    selectLocalGovernMentDeleteModal,
  );
  const pagesRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const handleAddLga = async () => {
    setLoading(true);
    const payload = {
      name: lganame,
    };

    try {
      const response = editmode
        ? await updateLga(localgovernment?.id, payload)
        : await createLga(payload);
      if (response) {
        toast.success(response?.message);
        dispatch(setLocalgovernmentModal(false));
        dispatch(setLocalgovernment(null));
        refetch();
        if (editmode) {
          dispatch(setEditMode(false));
        }
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (localgovernment) {
      setLganame(localgovernment?.name);
    } else {
      setLganame("");
    }
  }, [localgovernment]);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deleteLga(localgovernment?.id);
      if (response) {
        toast.success(response?.message);
        refetch();
        dispatch(setLocalgovernmentDeleteModal(false));
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const selectedButton = pagesRefs.current[currentPage];
    if (selectedButton) {
      selectedButton.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [currentPage]);

  return (
    <div className="flex flex-col gap-y-3 w-full">
      <div className="w-full flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <span className="text-sm sm:text-[16px] text-[#2A2E34] font-semibold">
          Local Government Areas Management
        </span>
        <ButtonV2
          title={"Add LGA"}
          image={PROFILE_ADD}
          btnStyle={
            "flex items-center justify-center gap-x-1 bg-globalGold px-3 py-2 rounded-xl flex-row-reverse w-full sm:w-auto"
          }
          textStyle={"text-[#FAFAFA] font-medium text-sm"}
          handleClick={() => {
            dispatch(setLocalgovernmentModal(true));
            dispatch(setLocalgovernment(null));
            dispatch(setEditMode(false));
          }}
        />
      </div>
      <div className="w-full flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="w-full sm:w-fit items-center gap-x-2 flex px-3 py-2 rounded-xl border border-borderColor">
          <img
            src={SEARCH_INPUT_ICON}
            className="w-[20px] h-[20px] flex-shrink-0"
            alt=""
          />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-transparent placeholder:text-sm outline-none"
            placeholder="Search LGA"
          />
        </div>
        <div className="w-full sm:w-fit px-5 py-2 rounded-xl border border-borderColor flex items-center gap-x-4">
          <div className="flex items-center gap-x-2">
            <img
              src={FILTER}
              className="w-[20px] h-[20px] flex-shrink-0"
              alt=""
            />
            <span className="text-sm font-normal text-[#808080]">
              All States
            </span>
          </div>
          <img
            src={CHEVRON_DOWN}
            className="w-[20px] h-[20px] flex-shrink-0"
            alt=""
          />
        </div>
      </div>

      <div className="w-full overflow-x-auto">
        {lga?.data?.length > 0 ? (
          <RoundedTable DATA={lga?.data} COLUMNS={LGA_COLUMN} />
        ) : loadingLga ? (
          <div className="flex items-center justify-center ">
            <Loader2 className="animate-spin" color="#d1d5db" size={30} />
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-center text-gray-500 p-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 mb-4 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.75 9.75h4.5m-4.5 4.5h4.5M12 21.75A9.75 9.75 0 1 0 12 2.25a9.75 9.75 0 0 0 0 19.5Z"
              />
            </svg>
            <h2 className="text-lg font-semibold">Nothing to display here</h2>
            <p className="text-sm text-gray-400 mt-1">
              Try uploading or selecting some content to get started.
            </p>
          </div>
        )}
      </div>
      {lga?.data?.length > 0 && (
        <div className="flex flex-col sm:flex-row items-center justify-between pt-3 px-3 sm:px-5 py-4 gap-4">
          <button
            type="button"
            onClick={() => setCurrentPage(lga?.meta?.current_page - 1)}
            disabled={lga?.meta?.current_page === 1}
            className={`border border-[#EBEBEB] rounded-xl w-[40px] h-[40px] lg:flex hidden items-center gap-x-2 justify-center ${
              lga?.meta?.current_page === 1 && ""
            }`}
          >
            <img src={CHEVRON_LEFT} className="w-[20px] h-[20px] " alt="" />
          </button>
          <div
            className={`flex items-center gap-x-2 ${
              lga?.meta?.links?.slice(1, -1).length > 5 &&
              "max-w-[200px] overflow-x-auto"
            }`}
          >
            {lga?.meta?.links?.slice(1, -1).map((page: any, index: number) => (
              <button
                ref={(el) => (pagesRefs.current[index] = el)}
                onClick={() => {
                  page.url && setCurrentPage(Number(page.label));
                }}
                className={`flex items-center justify-center pt-[0.5px] hover:bg-globalGold hover:text-white transition-all duration-300 gap-x-3 min-w-[40px] h-[40px] rounded-xl ${
                  page.active
                    ? "bg-globalGold text-white"
                    : "border text-[#2A2E34]"
                } `}
              >
                <span className={`text-[13px]`}>{page.label}</span>
              </button>
            ))}
          </div>
          <button
            type="button"
            onClick={() => setCurrentPage(lga?.meta?.current_page + 1)}
            disabled={lga?.meta?.current_page === lga?.meta?.last_page}
            className={`border border-[#EBEBEB] rounded-xl gap-x-2 w-[40px] h-[40px] lg:flex hidden items-center justify-center ${
              lga?.meta?.current_page === lga?.meta?.last_page && ""
            }`}
          >
            <img
              src={CHEVRON_LEFT}
              className="w-[20px] h-[20px] scale-x-[-1]"
              alt=""
            />
          </button>
        </div>
      )}
      <div
        className={`w-full h-full fixed ${
          localGovernmentModal ? "block" : "hidden"
        } top-0 left-0 bg-black flex items-center justify-center bg-opacity-50 z-[999]`}
      >
        {localGovernmentModal && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="w-[400px] bg-white rounded-xl shadow-xl right-6 z-50"
          >
            <div className="w-full flex items-center justify-between bg-[#00A63E1A] p-5">
              <h2 className="text-[16px] font-semibold text-[#2A2E34]">
                {editmode ? "Edit" : "Add  New"} LGA
              </h2>
              <button
                onClick={() => {
                  dispatch(setLocalgovernmentModal(false));

                  setLganame("");
                  dispatch(setEditMode(false));
                }}
                className="w-[30px] h-[30px] rounded-full -mt-2 flex items-center justify-center hover:bg-gray-200"
              >
                <img src={CLOSE} className="w-[20px] h-[20px]" alt="" />
              </button>
            </div>

            <div className="flex flex-col items-start w-full gap-y-1 p-5">
              <span className="text-sm font-medium text-[#4F5762]">
                Enter LGA Name
              </span>
              <div className="w-full h-[48px] rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                <input
                  type="text"
                  name=""
                  value={lganame}
                  onChange={(e) => setLganame(e.target.value)}
                  placeholder="Enter LGA name"
                  className="bg-transparent placeholder:text-sm w-full outline-none text-primary-300"
                />
              </div>
            </div>

            <div className="flex items-end justify-end gap-x-3 px-8 py-4">
              <ButtonV2
                title={"Cancel"}
                btnStyle={
                  "w-fit h-fit  px-7 py-2 rounded-xl border border-borderColor"
                }
                textStyle={"text-sm font-medium text-customDark "}
                handleClick={() => {
                  dispatch(setLocalgovernmentModal(false));

                  setLganame("");
                }}
              />
              <ButtonV2
                title={"Update"}
                btnStyle={"w-fit h-fit  px-7 py-2 rounded-xl bg-globalGold"}
                textStyle={"text-sm font-medium text-white "}
                loading={loading}
                loaderColor="#ffffff"
                handleClick={handleAddLga}
              />
            </div>
          </motion.div>
        )}
      </div>
      <ModalV2
        isOpen={localGovernmentDeleteModal || false}
        isClose={() => dispatch(setLocalgovernmentDeleteModal(false))}
        maxWidth={"w-[400px]"}
        edges={"rounded-xl"}
      >
        <div className="">
          <div className="border-b text-lg font-semibold text-customDark px-5 py-3 flex items-start">
            Confirm Delete
          </div>

          <div className="flex flex-col gap-y-2 items-center justify-center p-5">
            <span className="text-lg font-medium text-[#2A2E34]">
              Are you sure you want to delete the LGA 
              <span className="text-globalGold">”{localgovernment?.name}”</span>
              ? This action cannot be undone.
            </span>
          </div>

          <div className="flex w-full items-center gap-x-3 p-5">
            <ButtonV2
              title={"Cancel"}
              btnStyle={"w-full border border-borderColor rounded-xl p-3"}
              textStyle={"text-sm font-medium text-customDark"}
              handleClick={() => dispatch(setLocalgovernmentDeleteModal(false))}
            />
            <ButtonV2
              title={"Yes, Delete"}
              btnStyle={
                "w-full bg-[#FF3B2D] flex items-center justify-center rounded-xl p-3"
              }
              loaderColor="#ffffff"
              loading={loading}
              textStyle={"text-sm font-medium text-white"}
              handleClick={handleDelete}
            />
          </div>
        </div>
      </ModalV2>
    </div>
  );
}

export function JudicialDivision() {
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  // const [judicialDivisionModal, setJudicialDivisionModal] = useState(false)
  const judicialDivisionItem = useAppSelector(selectJudicialDivision);
  const editMode = useAppSelector(selectEditMode);
  const judicialDivisionModal = useAppSelector(selectJudicialModal);
  const judicialDeletModal = useAppSelector(selectJudicialDivisonDeleteModal);
  const [judicialName, setJudicialName] = useState("");
  const [currentpage, setCurrentPage] = useState(1);
  const {
    data: judicialDivision,
    refetch,
    isLoading: loadingDivision,
  } = useQuery(["division", currentpage], () =>
    getJudicialDivisionsAdmin(currentpage),
  );
  const filterDivision = judicialDivision?.data?.filter(
    (item: { name: string }) =>
      item.name?.toLowerCase().includes(searchQuery.toLowerCase()),
  );
  const pagesRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const handleAddDivision = async () => {
    setLoading(true);
    const payload = {
      name: judicialName,
    };

    try {
      const response = editMode
        ? await updateJudicialDivision(judicialDivisionItem?.id, payload)
        : await createJudicialDivision(payload);
      if (response) {
        toast.success(response?.message);
        dispatch(setJudicialDivisionModal(false));
        setJudicialName("");
        refetch();
        if (editMode) {
          dispatch(setEditMode(false));
        }
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (judicialDivisionItem) {
      setJudicialName(judicialDivisionItem?.name);
    }
  }, [judicialDivisionItem]);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deleteJudicialDivision(judicialDivisionItem?.id);
      if (response) {
        toast.success(response?.message);
        refetch();
        dispatch(setJudicialDivisionDeleteModal(false));
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const selectedButton = pagesRefs.current[currentpage];
    if (selectedButton) {
      selectedButton.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [currentpage]);
  return (
    <div className=" flex flex-col gap-y-3 w-full">
      <div className="w-full flex items-center justify-between">
        <span className="text-[16px] text-[#2A2E34] font-semibold">
          Judicial Divisions Management
        </span>
        <ButtonV2
          title={"Add Judicial Division"}
          image={PROFILE_ADD}
          btnStyle={
            "flex items-center justify-center gap-x-1 bg-globalGold px-3 py-2 rounded-xl flex-row-reverse"
          }
          textStyle={"text-[#FAFAFA] font-medium text-sm"}
          handleClick={() => dispatch(setJudicialDivisionModal(true))}
        />
      </div>
      <div className="w-full flex items-center justify-between">
        <div className="w-fit items-center gap-x-2 flex px-3 py-2 rounded-xl border border-borderColor">
          <img src={SEARCH_INPUT_ICON} className="w-[20px] h-[20px]" alt="" />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-transparent placeholder:text-sm outline-none"
            placeholder="Search judicial divisions"
          />
        </div>
        <div className="w-fit px-5 py-2 rounded-xl border border-borderColor flex items-center gap-x-4">
          <div className="flex items-center gap-x-2">
            <img src={FILTER} className="w-[20px] h-[20px]" alt="" />
            <span className="text-sm font-normal text-[#808080]">
              All States
            </span>
          </div>
          <img src={CHEVRON_DOWN} className="w-[20px] h-[20px]" alt="" />
        </div>
      </div>

      {/* <div className="w-[500px]">
        {judicialDivision?.length > 0 && (
          <RoundedTable DATA={judicialDivision} COLUMNS={JUDICIAL_COLUMN} />
        )}
      </div> */}
      <div className="w-full">
        {judicialDivision?.data?.length > 0 ? (
          <>
            <RoundedTable DATA={filterDivision} COLUMNS={JUDICIAL_COLUMN} />
            <div className="flex items-end justify-end pt-3 space-x-5 pr-5">
              <button
                type="button"
                onClick={() =>
                  setCurrentPage(judicialDivision?.meta?.current_page - 1)
                }
                disabled={judicialDivision?.meta?.current_page === 1}
                className={`border border-[#EBEBEB] rounded-xl w-[40px] h-[40px] lg:flex hidden items-center gap-x-2 justify-center ${
                  judicialDivision?.meta?.current_page === 1 && ""
                }`}
              >
                <img src={CHEVRON_LEFT} className="w-[20px] h-[20px] " alt="" />
              </button>
              <div
                className={`flex items-center gap-x-2 ${
                  judicialDivision?.meta?.links?.slice(1, -1).length > 5 &&
                  "max-w-[200px] overflow-x-auto"
                }`}
              >
                {judicialDivision?.meta?.links
                  ?.slice(1, -1)
                  .map((page: any, index: number) => (
                    <button
                      ref={(el) => (pagesRefs.current[index] = el)}
                      onClick={() => {
                        page.url && setCurrentPage(Number(page.label));
                      }}
                      className={`flex items-center justify-center pt-[0.5px] hover:bg-globalGold hover:text-white transition-all duration-300 gap-x-3 min-w-[40px] h-[40px] rounded-xl ${
                        page.active
                          ? "bg-globalGold text-white"
                          : "border text-[#2A2E34]"
                      } `}
                    >
                      <span className={`text-[13px]`}>{page.label}</span>
                    </button>
                  ))}
              </div>
              <button
                type="button"
                onClick={() =>
                  setCurrentPage(judicialDivision?.meta?.current_page + 1)
                }
                disabled={
                  judicialDivision?.meta?.current_page ===
                  judicialDivision?.meta?.last_page
                }
                className={`border border-[#EBEBEB] rounded-xl gap-x-2 w-[40px] h-[40px] lg:flex hidden items-center justify-center ${
                  judicialDivision?.meta?.current_page ===
                    judicialDivision?.meta?.last_page && ""
                }`}
              >
                <img
                  src={CHEVRON_LEFT}
                  className="w-[20px] h-[20px] scale-x-[-1]"
                  alt=""
                />
              </button>
            </div>
          </>
        ) : loadingDivision ? (
          <div className="flex items-center justify-center ">
            <Loader2 className="animate-spin" color="#d1d5db" size={30} />
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-center text-gray-500 p-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 mb-4 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.75 9.75h4.5m-4.5 4.5h4.5M12 21.75A9.75 9.75 0 1 0 12 2.25a9.75 9.75 0 0 0 0 19.5Z"
              />
            </svg>
            <h2 className="text-lg font-semibold">Nothing to display here</h2>
            <p className="text-sm text-gray-400 mt-1">
              Try uploading or selecting some content to get started.
            </p>
          </div>
        )}
      </div>
      <div
        className={`w-full h-full fixed ${
          judicialDivisionModal ? "block" : "hidden"
        } top-0 left-0 bg-black flex items-center justify-center bg-opacity-50 z-[999]`}
      >
        {judicialDivisionModal && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="w-[400px] bg-white rounded-xl shadow-xl right-6 z-50"
          >
            <div className="w-full flex items-center justify-between bg-[#00A63E1A] p-5">
              <h2 className="text-[16px] font-semibold text-[#2A2E34]">
                {editMode ? "Edit" : "Add  New"} Judicial Division
              </h2>
              <button
                onClick={() => {
                  dispatch(setJudicialDivisionModal(false));

                  setJudicialName("");
                  dispatch(setEditMode(false));
                }}
                className="w-[30px] h-[30px] rounded-full -mt-2 flex items-center justify-center hover:bg-gray-200"
              >
                <img src={CLOSE} className="w-[20px] h-[20px]" alt="" />
              </button>
            </div>

            <div className="flex flex-col items-start w-full gap-y-1 p-5">
              <span className="text-sm font-medium text-[#4F5762]">
                Enter Name
              </span>
              <div className="w-full h-[48px] rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                <input
                  type="text"
                  name=""
                  value={judicialName}
                  onChange={(e) => setJudicialName(e.target.value)}
                  placeholder="Enter name"
                  className="bg-transparent placeholder:text-sm w-full outline-none text-primary-300"
                />
              </div>
            </div>

            <div className="flex items-end justify-end gap-x-3 px-8 py-4">
              <ButtonV2
                title={"Cancel"}
                btnStyle={
                  "w-fit h-fit  px-7 py-2 rounded-xl border border-borderColor"
                }
                textStyle={"text-sm font-medium text-customDark "}
                handleClick={() => {
                  dispatch(setJudicialDivisionModal(false));

                  setJudicialName("");
                }}
              />
              <ButtonV2
                title={"Update"}
                btnStyle={"w-fit h-fit  px-7 py-2 rounded-xl bg-globalGold"}
                textStyle={"text-sm font-medium text-white "}
                loading={loading}
                loaderColor="#ffffff"
                handleClick={handleAddDivision}
              />
            </div>
          </motion.div>
        )}
      </div>
      <ModalV2
        isOpen={judicialDeletModal || false}
        isClose={() => dispatch(setJudicialDivisionDeleteModal(false))}
        maxWidth={"w-[400px]"}
        edges={"rounded-xl"}
      >
        <div className="">
          <div className="border-b text-lg font-semibold text-customDark px-5 py-3 flex items-start">
            Confirm Delete
          </div>

          <div className="flex flex-col gap-y-2 items-center justify-center p-5">
            <span className="text-lg font-medium text-[#2A2E34]">
              Are you sure you want to delete the Judicial Division? This action
              cannot be undone.
            </span>
          </div>

          <div className="flex w-full items-center gap-x-3 p-5">
            <ButtonV2
              title={"Cancel"}
              btnStyle={"w-full border border-borderColor rounded-xl p-3"}
              textStyle={"text-sm font-medium text-customDark"}
              handleClick={() =>
                dispatch(setJudicialDivisionDeleteModal(false))
              }
            />
            <ButtonV2
              title={"Yes, Delete"}
              btnStyle={
                "w-full bg-[#FF3B2D] flex items-center justify-center rounded-xl p-3"
              }
              loaderColor="#ffffff"
              loading={loading}
              textStyle={"text-sm font-medium text-white"}
              handleClick={handleDelete}
            />
          </div>
        </div>
      </ModalV2>
    </div>
  );
}
export function PlatformCharge() {
  const {
    data: platformCharge,
    refetch,
    isLoading,
  } = useQuery("platform", getPlatformCharge);
  const convertToArray = [platformCharge];
  const platformModal = useAppSelector(showPlatformChargeModal);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [acrStampFile, setAcrStampFile] = useState<File | null>(null);
  const [acrSealFile, setAcrSealFile] = useState<File | null>(null);

  useEffect(() => {
    if (platformCharge?.platform_charge) {
      setAmount(platformCharge.platform_charge.toString());
    }
  }, [platformCharge]);

  const handleCloseModal = () => {
    dispatch(setPlatformModal(false));
    setAcrStampFile(null);
    setAcrSealFile(null);
  };

  const handleUpdatePlatformCharge = async () => {
    setLoading(true);
    const formData = new FormData();
    if (amount) {
      formData.append("platform_charge", amount);
    }
    if (acrStampFile) {
      formData.append("acr_stamp_path", acrStampFile);
    }
    if (acrSealFile) {
      formData.append("acr_seal_path", acrSealFile);
    }

    try {
      const response = await updatePlatformCharge(formData);
      if (response) {
        toast.success(response?.message || "Settings updated successfully");
        refetch();
        handleCloseModal();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className=" flex flex-col gap-y-3 w-[700px]">
      <div className="w-full flex items-center justify-between">
        <span className="text-[16px] text-[#2A2E34] font-semibold">
          Site Settings
        </span>
        <ButtonV2
          title={"Update Settings"}
          image={EDIT_ICON}
          btnStyle={
            "flex items-center justify-center gap-x-1 bg-globalGold px-3 py-2 rounded-xl flex-row-reverse"
          }
          textStyle={"text-[#FAFAFA] font-medium text-sm"}
          handleClick={() => dispatch(setPlatformModal(true))}
        />
      </div>

      <div className="w-full">
        {platformCharge ? (
          <>
            <RoundedTable DATA={convertToArray} COLUMNS={PLATFORM_CHARGE} />
            <div className="mt-6 flex gap-8 items-center bg-white p-5 rounded-xl border border-borderColor">
              <div className="flex flex-col items-center">
                <span className="text-sm font-semibold text-[#2A2E34] mb-2">
                  ACR Seal/Stamp
                </span>
                {platformCharge.acr_stamp_path ? (
                  <img
                    src={platformCharge.acr_stamp_path}
                    alt="ACR Stamp"
                    className="object-contain h-[120px] w-[120px] border border-gray-200 rounded-lg p-1"
                  />
                ) : (
                  <div className="h-[120px] w-[120px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-xs text-gray-400">
                    No Stamp
                  </div>
                )}
              </div>
              <div className="flex flex-col items-center">
                <span className="text-sm font-semibold text-[#2A2E34] mb-2">
                  ACR Signature
                </span>
                {platformCharge.acr_seal_path ? (
                  <img
                    src={platformCharge.acr_seal_path}
                    alt="ACR Seal"
                    className="object-contain h-[120px] w-[120px] border border-gray-200 rounded-lg p-1"
                  />
                ) : (
                  <div className="h-[120px] w-[120px] border border-dashed border-gray-300 rounded-lg flex items-center justify-center text-xs text-gray-400">
                    No Seal
                  </div>
                )}
              </div>
            </div>
          </>
        ) : isLoading ? (
          <div className="flex items-center justify-center ">
            <Loader2 color="#d1d5db" className="animate-spin" size={30} />
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-center text-gray-500 p-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 mb-4 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.75 9.75h4.5m-4.5 4.5h4.5M12 21.75A9.75 9.75 0 1 0 12 2.25a9.75 9.75 0 0 0 0 19.5Z"
              />
            </svg>
            <h2 className="text-lg font-semibold">Nothing to display here</h2>
            <p className="text-sm text-gray-400 mt-1">
              Try uploading or selecting some content to get started.
            </p>
          </div>
        )}
      </div>

      <div
        className={`w-full h-full fixed ${
          platformModal ? "block" : "hidden"
        } top-0 left-0 bg-black flex items-center justify-center bg-opacity-50 z-[999]`}
      >
        {platformModal && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="w-[400px] bg-white rounded-xl shadow-xl right-6 z-50 max-h-[90vh] overflow-y-auto"
          >
            <div className="w-full flex items-center justify-between bg-lightGold p-5">
              <h2 className="text-[16px] font-semibold text-[#2A2E34]">
                Update Site Settings
              </h2>
              <button
                onClick={handleCloseModal}
                className="w-[30px] h-[30px] rounded-full -mt-2 flex items-center justify-center hover:bg-gray-200"
              >
                <img src={CLOSE} className="w-[20px] h-[20px]" alt="" />
              </button>
            </div>

            <div className="flex flex-col items-start w-full gap-y-1 p-5 border-b border-borderColor">
              <span className="text-sm font-medium text-[#4F5762]">
                Platform Charge Amount (₦)
              </span>
              <div className="w-full h-[48px] rounded-xl px-3 border border-borderColor shadow-box flex items-center gap-x-2">
                <input
                  type="text"
                  name=""
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="12,900"
                  className="bg-transparent placeholder:text-sm w-full outline-none text-primary-300"
                />
              </div>
            </div>

            <div className="flex flex-col items-start w-full gap-y-1 p-5 border-b border-borderColor">
              <span className="text-sm font-medium text-[#4F5762]">
                ACR Seal/Stamp Image
              </span>
              <div className="w-full flex items-center gap-x-3">
                <label className="cursor-pointer bg-gray-100 hover:bg-gray-200 border border-borderColor px-4 py-2 rounded-xl text-sm font-medium text-customDark">
                  Choose File
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        setAcrStampFile(e.target.files[0]);
                      }
                    }}
                  />
                </label>
                <span className="text-xs text-gray-500 truncate max-w-[200px]">
                  {acrStampFile
                    ? acrStampFile.name
                    : platformCharge?.acr_stamp_path
                      ? "Keep existing file"
                      : "No file chosen"}
                </span>
              </div>
            </div>

            <div className="flex flex-col items-start w-full gap-y-1 p-5">
              <span className="text-sm font-medium text-[#4F5762]">
                ACR Signature Image
              </span>
              <div className="w-full flex items-center gap-x-3">
                <label className="cursor-pointer bg-gray-100 hover:bg-gray-200 border border-borderColor px-4 py-2 rounded-xl text-sm font-medium text-customDark">
                  Choose File
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        setAcrSealFile(e.target.files[0]);
                      }
                    }}
                  />
                </label>
                <span className="text-xs text-gray-500 truncate max-w-[200px]">
                  {acrSealFile
                    ? acrSealFile.name
                    : platformCharge?.acr_seal_path
                      ? "Keep existing file"
                      : "No file chosen"}
                </span>
              </div>
            </div>

            <div className="flex items-end justify-end gap-x-3 px-8 py-4">
              <ButtonV2
                title={"Cancel"}
                btnStyle={
                  "w-fit h-fit  px-7 py-2 rounded-xl border border-borderColor"
                }
                textStyle={"text-sm font-medium text-customDark "}
                handleClick={handleCloseModal}
              />
              <ButtonV2
                title={"Update"}
                btnStyle={"w-fit h-fit  px-7 py-2 rounded-xl bg-globalGold"}
                textStyle={"text-sm font-medium text-white "}
                loading={loading}
                loaderColor="#ffffff"
                handleClick={handleUpdatePlatformCharge}
              />
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
}
